/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { request } from '../../config/helpers/axios-instance';

// Delivery tracking timeline. Extracted VERBATIM from src/pages/delivery/index.jsx so the
// legacy page and the logistics console open the same modal rather than two takes on it --
// same reasoning as DeliveryCreateModal. No behaviour change: it still fetches
// GET /delivery/track/:id itself when it mounts.
const DeliveryTrackingModal = ({ deliveryData }) => {
    const [trackingDetails, setTrackingDetails] = useState(null)

    const trackOrder = async (id) => {
        if (!id) {
            toast.warn("Invalid ID")
            return;
        }

        try {
            const response = await request({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                url: `delivery/track/${id}`,
            });

            if (response.data && response.data.success) {
                return response.data?.data
            } else {
                toast.error("Error tracking order");
            }
        } catch (error) {
            toast.error("Error tracking order");
        }
    }

    useEffect(() => {
        (async () => {
            if (deliveryData) {
                const trackingDetails = await trackOrder(deliveryData.id)
                setTrackingDetails(trackingDetails)
            }
        })()
    }, [deliveryData])

    return (
        <div className='flex flex-col gap-[0.9rem]' >
            <div className='flex justify-between' >
                <span className='text-[1.5rem] font-bold' >Delivery Tracking</span>
                <span className='text-[1.2rem]' >Order ID: <span className='text-[1.2rem] font-semibold' >{`#${deliveryData.id}`}</span></span>
            </div>
            <hr />
            {trackingDetails && (
                <div className='tracking-timeline relative'>
                    <div className='flex justify-between items-center my-4' >
                        <h2 className='tracking-details-title text-lg font-semibold'>Tracking Details</h2>
                        <div className='flex items-end justify-end mb-4 text-sm text-gray-600'>
                            <div className='flex items-center space-x-2'>
                                <span className='bg-green-100 text-[#00A48B] px-2 py-1 rounded-full text-xs font-medium'>Latest</span>
                                <svg className='w-4 h-4 text-gray-400' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 10l-7-7m0 0l-7 7m7-7v18' />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div>
                        {trackingDetails?.status && (
                            <div className='mb-6 p-4 bg-gray-50 rounded-lg border'>
                                <div className='flex items-center justify-between'>
                                    <span className='text-sm font-medium text-gray-600'>Current Status:</span>
                                    <span className='px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-800'>
                                        {trackingDetails.status}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Content items */}
                    <div className='space-y-6 w-full h-96 overflow-y-auto '>
                        {trackingDetails?.trackDetails?.length > 0 && trackingDetails?.trackDetails?.map((detail, index) => (
                            <div key={index} className='flex items-center w-full gap-6 box-border'>
                                <div
                                    key={`dot-${index}`}
                                    className='w-4 h-4 bg-[#00A48B] rounded-full border-2 border-white shadow-md z-10'
                                />
                                <div className='flex-1 tracking-item-content bg-white border border-gray-200 rounded-lg shadow-sm p-5 hover:shadow-md transition-shadow duration-200'>
                                    <div className='flex flex-col space-y-3'>
                                        <h3 className='tracking-item-action text-lg font-semibold text-gray-900 leading-tight'>
                                            {detail.action}
                                        </h3>

                                        <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
                                            <div className='flex items-center space-x-2'>
                                                <span className='text-sm font-medium text-gray-500'>Status Code:</span>
                                                <span className='tracking-item-code bg-blue-50 text-[#00A48B] px-2 py-1 rounded text-sm font-mono'>
                                                    {detail.code}
                                                </span>
                                            </div>

                                            <div className='flex items-center space-x-2'>
                                                <span className='text-sm font-medium text-gray-500'>Date:</span>
                                                <time className='tracking-item-date text-sm font-medium text-gray-700'>
                                                    {new Date(detail.dateTime).toLocaleString()}
                                                </time>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div >
    )
}

export default DeliveryTrackingModal;
